import { useMutation } from "@tanstack/react-query";
import { Button, Col, Form } from "react-bootstrap";
import Select from "react-select";
import LoadingButton from "../../../components/loading/LoadingButton";
import Card from "../../../components/ui/div/Card";
import useUserInformation from "../../../hooks/useUserInformation";
import { getAuthMethod } from "../../../modules/helper";
import FilterShipments from "../../districtManager/components/FilterShipments";
import FilterTime from "../../districtManager/components/FilterTime";
import useCity from "../functions/useCity";

function Filter({ searchParams, set, isLoading, get }) {
  const { user } = useUserInformation();
  const { cities } = useCity({ provinceId: user?.supervisor?.provinceId });

  const { data: agents, mutate: getAgents } = useMutation({
    mutationKey: ["todayAgents"],
    mutationFn: id =>
      getAuthMethod("/agent/v1/city-agents?cityId=" + id).then(
        res => res.data.agents
      ),
  });

  const getCityOptions = () => {
    const array = [{ label: "...", value: 0 }];
    cities.map(item => array.push({ label: item.faName, value: item.id }));
    return array;
  };

  const getDefaultCity = name => {
    const find = getCityOptions().find(
      item => item.value === parseInt(searchParams.get(name))
    );

    return find ? find : { label: "...", value: 0 };
  };

  return (
    <section>
      <form
        onSubmit={e => {
          e.preventDefault();
          get();
        }}
      >
        <Card className="d-flex flex-wrap column-gap-3 row-gap-2 pb-2">
          <FilterShipments value={searchParams} set={set} />

          <div className="w-100 mt-2">
            <h5 className="mb-1">فرستنده</h5>
            <div className="d-flex flex-wrap column-gap-3 row-gap-2">
              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>شهر:</Form.Label>
                <Select
                  options={getCityOptions()}
                  value={getDefaultCity("senderCity")}
                  isSearchable={true}
                  onChange={({ value }) => {
                    set({ label: "senderCity", value });
                    set({ label: "agent", value: 0 });
                    getAgents(value);
                  }}
                />
              </Col>

              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>نماینده:</Form.Label>
                <Form.Select
                  onClick={e => set({ label: "agent", value: e.target.value })}
                >
                  <option value={0} defaultValue={searchParams.get("agent")}>
                    همه
                  </option>
                  {agents?.length > 0 &&
                    agents.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.user.name + " " + item.user.family}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            </div>
          </div>

          <div className="w-100 mt-2 d-flex flex-wrap column-gap-3 row-gap-2">
            <FilterTime searchParams={searchParams} set={set} />
            <Col
              xs="12"
              sm="5"
              lg="3"
              xxl="2"
              className="d-flex justify-content-end align-items-end me-auto"
            >
              {isLoading === true && (
                <LoadingButton title="در حال دریافت" className="btn-primary" />
              )}
              {isLoading === false && <Button type="submit">فیلتر</Button>}
            </Col>
          </div>
        </Card>
      </form>
    </section>
  );
}

export default Filter;
